import { toast } from 'react-toastify'
import { BehaviorSubject } from 'rxjs'
import { deleteAllCookies, getCookieInArray, getCookieString, updateCookiesArray, logPossibleBase64Cookies } from '../utils/cookies'
import { fetchHasuraToken } from '../service/hasuraTokenService'

const currentTokenSubject = new BehaviorSubject(getCookieString('base64AuthAccess'))

export const auth = {
	currentToken: currentTokenSubject.asObservable(),
	get currentTokenValue() {
		return currentTokenSubject.value
	},
}

export const verifyLogin365 = () => {
	console.log('[auth] Verificando cookies de autenticação...')
	// Loga possíveis cookies base64 para inspeção (somente em dev)
	if (process.env.NODE_ENV !== 'production') {
		logPossibleBase64Cookies()
	}
	if (!document.cookie) {
		console.warn('[auth] Nenhum cookie presente')
		return
	}
	updateCookiesArray()

	// Backend usa 'authError'
	const authError = getCookieInArray('authError') || getCookieInArray('error')
	if (authError) {
		console.error('[auth] Erro de autenticação:', authError.value)
		toast.error(`Erro de autenticação: ${authError.value}`)
		// Limpa cookie de erro para não repetir
		document.cookie = 'authError=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
		document.cookie = 'error=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/'
		return
	}

	const token = getCookieInArray('base64AuthAccess')
	if (token && token.value && token.value !== 'undefined') {
		if (currentTokenSubject.value !== token.value) {
			console.log('[auth] Token atualizado')
			currentTokenSubject.next(token.value)
			// Busca token específico do Hasura
			fetchHasuraToken(true)
		}
	} else {
		console.warn('[auth] Token não encontrado nos cookies')
	}
}

export const isAuthenticated = () => {
	return Boolean(auth.currentTokenValue || localStorage.getItem('accessToken'))
}

let cachedUserId = null

// export const getUserId = () => {
// 	if (cachedUserId) return cachedUserId

// 	const raw = getCookieString('base64Id')
// 	if (raw && raw !== 'undefined') {
// 		let candidate = raw

// 		// 1. URL decode (best effort)
// 		try {
// 			candidate = decodeURIComponent(candidate)
// 		} catch {}

// 		// 2. Base64 decode if it looks like base64
// 		if (/^[A-Za-z0-9+/=]+$/.test(candidate) && candidate.length % 4 === 0) {
// 			try {
// 				const b64Decoded = atob(candidate)
// 				// Prefer decoded text if it stays printable
// 				if (b64Decoded) candidate = b64Decoded
// 			} catch (e) {
// 				console.warn('[auth] Falha ao decodificar base64Id (base64)', e)
// 			}
// 		}

// 		// 3. Tentar interpretar como JSON contendo { id: ... }
// 		let parsed = null
// 		if (/^\s*{/.test(candidate)) {
// 			try {
// 				parsed = JSON.parse(candidate)
// 			} catch (e) {
// 				console.warn('[auth] Falha ao fazer JSON.parse em base64Id', e)
// 			}
// 		}

// 		const userId = parsed?.id || candidate
// 		if (userId && typeof userId === 'string') {
// 			cachedUserId = userId
// 			console.log('[auth] UserId obtido do cookie base64Id:', cachedUserId)
// 			return cachedUserId
// 		}
// 	}

// 	// 4. Fallback: extrair de JWT atual
// 	const token = auth.currentTokenValue
// 	if (token && token.split('.').length === 3) {
// 		try {
// 			const payload = JSON.parse(atob(token.split('.')[1]))
// 			const possible =
// 				payload['X-Hasura-User-Id'] ||
// 				payload['https://hasura.io/jwt/claims']?.['x-hasura-user-id'] ||
// 				payload['sub'] ||
// 				payload['id']
// 			if (possible) {
// 				cachedUserId = possible
// 				return cachedUserId
// 			}
// 		} catch (e) {
// 			console.warn('[auth] Não foi possível extrair userId do token access', e)
// 		}
// 	}

// 	return null
// }
export const getUserId = () => {
  return localStorage.getItem("userId")
}

export const logout = () => {
	deleteAllCookies()
	currentTokenSubject.next(null)
	const backend = process.env.REACT_APP_BACKEND
	if (backend) {
		window.location.replace(`${backend}/auth/logout`)
	} else {
		window.location.replace('/')
	}
}